export default __webpack_public_path__ + "static/pomtimer-cbd9a23fcadf36c4ebb04e6272265c60.mp4";